import { BankCode } from "@/proto/b-enterprise/v1/fastcheckout/all_pb";
import { BankInfo, Countries } from "./types";

export const SOURCE_BANKS: BankInfo[] = [
  {
    title: "Bank Central Asia",
    name: "BCA_CORPORATE",
  },
  {
    title: "Bank Negara Indonesia",
    name: "BNI_CORPORATE",
  },
  {
    title: "Bank Rakyat Indonesia",
    name: "BRI_CORPORATE",
  },
  {
    title: "Permata Bank",
    name: "PERMATA_CORPORATE",
  },
  {
    title: "Transferwise",
    name: "TRANSFERWISE",
  },
  {
    title: "Union Bank",
    name: "UNIONBANK_CORPORATE",
  },
  {
    title: "Banco De Oro Unibank",
    name: "BDO_CORPORATE",
  },
  {
    title: "CIMB Bank",
    name: "CIMB_CORPORATE",
  },
];

export const DESTINATION_BANKS: BankInfo[] = [
  // Philippines
  {
    title: "Banco De Oro Unibank",
    name: "PH_BDO",
  },
  {
    title: "Union Bank",
    name: "PH_UB",
  },
  {
    title: "BPI / BPI Family Savings Bank",
    name: "PH_BPI",
  },
  {
    title: "Metrobank",
    name: "PH_METRO",
  },
  // Indonesia
  {
    title: "Bank Negara Indonesia",
    name: "ID_BNI",
  },
  {
    title: "Bank Rakyat Indonesia",
    name: "ID_BRI",
  },
  {
    title: "Bank Central Asia",
    name: "ID_BCA",
  },
  {
    title: "Permata Bank",
    name: "ID_PERMATA",
  },
];

/**
 * TODO: So far we only supports BPI when creating BankSecret
 * Need to update this list later after we supports more
 */
export const SUPPORTED_INTEGRATION_BANKS: BankInfo[] = [
  {
    title: "BPI Direct",
    name: "PH_BPI",
    logo: "bank-logos/PH/BPI.svg",
  },
  {
    title: "BPI Disburse",
    name: "BPI_CORPORATE",
    logo: "bank-logos/PH/BPI.svg",
  },
  {
    title: "GCash",
    name: "PH_GXI",
    logo: "bank-logos/PH/GCash.png",
  },
  {
    title: "ESPay",
    name: "ID_ESP",
    logo: "bank-logos/ID/ESPAY.png",
  },
  {
    title: "RCBC Direct",
    name: "PH_RCBC",
    logo: "bank-logos/PH/RCBC.svg",
  },
  {
    title: "QRPH Direct",
    name: "PH_ALLBANK",
    logo: "bank-logos/PH/QRPH.png",
  },
  {
    title: "BRI Direct Debit",
    name: "ID_BRI",
    logo: "bank-logos/ID/BRI-Direct.png",
  },
];

export const COUNTRY_LIST: Countries[] = [
  { label: "All Countries", value: "" },
  { label: "Indonesia", value: "Indonesia" },
  { label: "Singapore", value: "Singapore" },
  { label: "Malaysia", value: "Malaysia" },
  { label: "Philippines", value: "Philippines" },
  { label: "Vietnam", value: "Vietnam" },
  { label: "Thailand", value: "Thailand" },
  { label: "Algeria", value: "Algeria" },
  { label: "Andorra", value: "Andorra" },
  { label: "Angola", value: "Angola" },
  { label: "Anguilla", value: "Anguilla" },
  { label: "Antigua Barbuda", value: "Antigua" },
  { label: "Argentina", value: "Argentina" },
  { label: "Armenia", value: "Armenia" },
  { label: "Aruba", value: "Aruba" },
  { label: "Australia", value: "Australia" },
  { label: "Austria", value: "Austria" },
  { label: "Azerbaijan", value: "Azerbaijan" },
  { label: "Bahamas", value: "Bahamas" },
  { label: "Bahrain", value: "Bahrain" },
  { label: "Bangladesh", value: "Bangladesh" },
  { label: "Barbados", value: "Barbados" },
  { label: "Belarus", value: "Belarus" },
  { label: "Belgium", value: "Belgium" },
  { label: "Belize", value: "Belize" },
  { label: "Benin", value: "Benin" },
  { label: "Bermuda", value: "Bermuda" },
  { label: "Bhutan", value: "Bhutan" },
  { label: "Bolivia", value: "Bolivia" },
  { label: "Bosnia Herzegovina", value: "BosniaHerzegovina" },
  { label: "Botswana", value: "Botswana" },
  { label: "Brazil", value: "Brazil" },
  { label: "Brunei", value: "Brunei" },
  { label: "Bulgaria", value: "Bulgaria" },
  { label: "BurkinaFaso", value: "BurkinaFaso" },
  { label: "Burundi", value: "Burundi" },
  { label: "Cambodia", value: "Cambodia" },
  { label: "Cameroon", value: "Cameroon" },
  { label: "Canada", value: "Canada" },
  { label: "Cape Verde Islands", value: "CapeVerdeIslands" },
  { label: "Cayman Islands", value: "CaymanIslands" },
  { label: "Central African Republic", value: "CentralAfricanRepublic" },
  { label: "Chile", value: "Chile" },
  { label: "China", value: "China" },
  { label: "Colombia", value: "Colombia" },
  { label: "Comoros", value: "Comoros" },
  { label: "Congo", value: "Congo" },
  { label: "Cook Islands", value: "CookIslands" },
  { label: "Costa Rica", value: "CostaRica" },
  { label: "Croatia", value: "Croatia" },
  { label: "Cyprus - North", value: "CyprusNorth" },
  { label: "Cyprus - South", value: "CyprusSouth" },
  { label: "Czech Republic", value: "CzechRepublic" },
  { label: "Denmark", value: "Denmark" },
  { label: "Djibouti", value: "Djibouti" },
  { label: "Dominica", value: "Dominica" },
  { label: "Dominican Republic", value: "DominicanRepublic" },
  { label: "Ecuador", value: "Ecuador" },
  { label: "Egypt", value: "Egypt" },
  { label: "El Salvador", value: "ElSalvador" },
  { label: "Equatorial Guinea", value: "EquatorialGuinea" },
  { label: "Eritrea", value: "Eritrea" },
  { label: "Estonia", value: "Estonia" },
  { label: "Falkland Islands", value: "FalklandIslands" },
  { label: "Faroe Islands", value: "FaroeIslands" },
  { label: "Fiji", value: "Fiji" },
  { label: "Finland", value: "Finland" },
  { label: "France", value: "France" },
  { label: "French Guiana", value: "FrenchGuiana" },
  { label: "French Polynesia", value: "FrenchPolynesia" },
  { label: "Gabon", value: "Gabon" },
  { label: "Gambia", value: "Gambia" },
  { label: "Georgia", value: "Georgia" },
  { label: "Germany", value: "Germany" },
  { label: "Ghana", value: "Ghana" },
  { label: "Gibraltar", value: "Gibraltar" },
  { label: "Greece", value: "Greece" },
  { label: "Greenland", value: "Greenland" },
  { label: "Grenada", value: "Grenada" },
  { label: "Guadeloupe", value: "Guadeloupe" },
  { label: "Guam", value: "Guam" },
  { label: "Guatemala", value: "Guatemala" },
  { label: "Guinea - Bissau", value: "GuineaBissau" },
  { label: "Guyana", value: "Guyana" },
  { label: "Haiti", value: "Haiti" },
  { label: "Honduras", value: "Honduras" },
  { label: "HongKong", value: "HongKong" },
  { label: "Hungary", value: "Hungary" },
  { label: "Hungary", value: "Hungary" },
  { label: "Iceland", value: "Iceland" },
  { label: "India", value: "India" },
  { label: "Iraq", value: "Iraq" },
  { label: "Ireland", value: "Ireland" },
  { label: "Israel", value: "Israel" },
  { label: "Italy", value: "Italy" },
  { label: "Jamaica", value: "Jamaica" },
  { label: "Japan", value: "Japan" },
  { label: "Jordan", value: "Jordan" },
  { label: "Kazakhstan", value: "Kazakhstan" },
  { label: "Kenya", value: "Kenya" },
  { label: "Kiribati", value: "Kiribati" },
  { label: "Korea - South", value: "KoreaSouth" },
  { label: "Kuwait", value: "Kuwait" },
  { label: "Kyrgyzstan", value: "Kyrgyzstan" },
  { label: "Laos", value: "Laos" },
  { label: "Latvia", value: "Latvia" },
  { label: "Lebanon", value: "Lebanon" },
  { label: "Lesotho", value: "Lesotho" },
  { label: "Liberia", value: "Liberia" },
  { label: "Libya", value: "Libya" },
  { label: "Liechtenstein", value: "Liechtenstein" },
  { label: "Lithuania", value: "Lithuania" },
  { label: "Luxembourg", value: "Luxembourg" },
  { label: "Macao", value: "Macao" },
  { label: "Macedonia", value: "Macedonia" },
  { label: "Madagascar", value: "Madagascar" },
  { label: "Malawi", value: "Malawi" },
  { label: "Maldives", value: "Maldives" },
  { label: "Mali", value: "Mali" },
  { label: "Malta", value: "Malta" },
  { label: "Marshall Islands", value: "MarshallIslands" },
  { label: "Martinique", value: "Martinique" },
  { label: "Mauritania", value: "Mauritania" },
  { label: "Mayotte", value: "Mayotte" },
  { label: "Mexico", value: "Mexico" },
  { label: "Micronesia", value: "Micronesia" },
  { label: "Moldova", value: "Moldova" },
  { label: "Mongolia", value: "Mongolia" },
  { label: "Montserrat", value: "Montserrat" },
  { label: "Morocco", value: "Morocco" },
  { label: "Mozambique", value: "Mozambique" },
  { label: "Myanmar", value: "Myanmar" },
  { label: "Namibia", value: "Namibia" },
  { label: "Nauru", value: "Nauru" },
  { label: "Nepal", value: "Nepal" },
  { label: "Netherlands", value: "Netherlands" },
  { label: "New Caledonia", value: "NewCaledonia" },
  { label: "New Zealand", value: "NewZealand" },
  { label: "Netherlands", value: "Netherlands" },
  { label: "Nicaragua", value: "Nicaragua" },
  { label: "Niger", value: "Niger" },
  { label: "Nigeria", value: "Nigeria" },
  { label: "Niue", value: "Niue" },
  { label: "NorfolkIslands", value: "NorfolkIslands" },
  { label: "Northern Marianas", value: "NorthernMarianas" },
  { label: "Norway", value: "Norway" },
  { label: "Oman", value: "Oman" },
  { label: "Pakistan", value: "Pakistan" },
  { label: "Palau", value: "Palau" },
  { label: "Panama", value: "Panama" },
  { label: "Papua New Guinea", value: "PapuaNewGuinea" },
  { label: "Paraguay", value: "Paraguay" },
  { label: "Peru", value: "Peru" },
  { label: "Poland", value: "Poland" },
  { label: "Portugal", value: "Portugal" },
  { label: "Puerto Rico", value: "PuertoRico" },
  { label: "Qatar", value: "Qatar" },
  { label: "Reunion", value: "Reunion" },
  { label: "Romania", value: "Romania" },
  { label: "Russia", value: "Russia" },
  { label: "Rwanda", value: "Rwanda" },
  { label: "San Marino", value: "SanMarino" },
  { label: "Sao Tome Principe", value: "SaoTomePrincipe" },
  { label: "Saudi Arabia", value: "SaudiArabia" },
  { label: "Senegal", value: "Senegal" },
  { label: "Serbia", value: "Serbia" },
  { label: "Seychelles", value: "Seychelles" },
  { label: "Sierra Leone", value: "SierraLeone" },
  { label: "Slovak Republic", value: "SlovakRepublic" },
  { label: "Slovenia", value: "Slovenia" },
  { label: "Solomon Islands", value: "SolomonIslands" },
  { label: "Somalia", value: "Somalia" },
  { label: "South Africa", value: "SouthAfrica" },
  { label: "Spain", value: "Spain" },
  { label: "Sri Lanka", value: "SriLanka" },
  { label: "St. Helena", value: "StHelena" },
  { label: "St. Kitts", value: "StKitts" },
  { label: "St. Lucia", value: "StLucia" },
  { label: "Suriname", value: "Suriname" },
  { label: "Sudan", value: "Sudan" },
  { label: "Swaziland", value: "Swaziland" },
  { label: "Sweden", value: "Sweden" },
  { label: "Switzerland", value: "Switzerland" },
  { label: "Taiwan", value: "Taiwan" },
  { label: "Tajikistan", value: "Tajikistan" },
  { label: "Togo", value: "Togo" },
  { label: "Tonga", value: "Tonga" },
  { label: "TrinidadTobago", value: "TrinidadTobago" },
  { label: "Tunisia", value: "Tunisia" },
  { label: "Turkey", value: "Turkey" },
  { label: "Turkmenistan", value: "Turkmenistan" },
  { label: "Turks Caicos Islands", value: "TurksCaicosIslands" },
  { label: "Tuvalu", value: "Tuvalu" },
  { label: "Uganda", value: "Uganda" },
  { label: "Ukraine", value: "Ukraine" },
  { label: "United Arab Emirates", value: "UnitedArabEmirates" },
  { label: "United Kingdom", value: "UnitedKingdom" },
  { label: "United States of America", value: "USA" },
  { label: "Uruguay", value: "Uruguay" },
  { label: "Uzbekistan", value: "Uzbekistan" },
  { label: "Vanuatu", value: "Vanuatu" },
  { label: "Vatican City", value: "VaticanCity" },
  { label: "Venezuela", value: "Venezuela" },
  { label: "Virgin Islands - British", value: "VirginIslandsBritish" },
  { label: "Virgin Islands - US", value: "VirginIslandsUS" },
  { label: "Yemen (North)", value: "YemenNorth" },
  { label: "Yemen (South)", value: "YemenSouth" },
  { label: "Zambia", value: "Zambia" },
  { label: "Zimbabwe", value: "Zimbabwe" },
];

export const COUNTRY_MOBILE_CODES: Record<string, string> = {
  Indonesia: "+62",
  Malaysia: "+60",
  Philippines: "+63",
  Singapore: "+65",
  Thailand: "+66",
  Vietnam: "+84",
};

export const TIME_ZONES: Record<string, string> = {
  Indonesia: "GMT+7",
  Malaysia: "GMT+8",
  Philippines: "GMT+8",
  Singapore: "GMT+8",
  Thailand: "GMT+7",
  Vietnam: "GMT+7",
};

// Mapping destination bank codes to support for create/update Destination Account
export const STATEMENT_BANK_CODE_MAPPING: Record<number, string> = {
  [BankCode.DUMMY_BANK_PERSONAL]: "Brankas Bank",

  // Philippines banks
  [BankCode.BDO_PERSONAL]: "Banco De Oro Unibank",
  [BankCode.BPI_PERSONAL]: "BPI / BPI Family Savings Bank",
  [BankCode.METROBANK_PERSONAL]: "Metrobank",
  [BankCode.PNB_PERSONAL]: "Philippine National Bank",
  [BankCode.RCBC_PERSONAL]: "Rizal Commercial Banking Corporation",
  [BankCode.UNIONBANK_PERSONAL]: "UnionBank of the Philippines",

  // Indonesia banks
  [BankCode.MANDIRI_PERSONAL]: "Bank Mandiri",
  [BankCode.BNI_PERSONAL]: "BNI / Bank Negara Indonesia",
  [BankCode.BRI_PERSONAL]: "BRI / Bank Rakyat Indonesia",
  [BankCode.BCA_PERSONAL]: "BCA / Bank Central Asia",

  // Thailand banks
  [BankCode.KASIKORNBANK_PERSONAL]: "Kasikornbank",
};
